import { StatsGl, useGLTF } from '@react-three/drei';

import * as THREE from 'three';
import type { GLTF } from 'three/examples/jsm/Addons.js';

import { Brush } from './components/sprite-bushes';
import { Campfire } from './components/campfire/campfire';
import { IslandEnvironment } from './components/enviroment';
import { PlatForm } from './components/platform/platform';
import { Island } from './components/island';
import { Waterfall } from './components/waterfall';
import { Suspense } from 'react';
import { FlyingObjects } from './components/models/flyingObjects';
import Leaves from './components/leaves';
import { Controllers } from './components/controllers';
import { StaticCollider } from 'bvhecctrl';

export type IslandType = GLTF & {
  nodes: {
    island_geo003: THREE.Mesh; //grass plane
    island_geo003_1: THREE.Mesh; //river
    island_geo003_2: THREE.Mesh; //stream
    island_geo003_3: THREE.Mesh; //waterfall
    island_geo003_4: THREE.Mesh; //waterfall edge
    island_geo003_5: THREE.Mesh; //plane topside
    island_geo003_6: THREE.Mesh; //plane waterfall side
    island_geo003_7: THREE.Mesh; //rocks
    tree_bare_fat: THREE.Mesh;
    tree_bare_fat001: THREE.Mesh;
    tree_bare_fat002: THREE.Mesh;
    tree_bare_fat003: THREE.Mesh;
    tree_bare_fat004: THREE.Mesh;
    tree_bare_fat005: THREE.Mesh;
    tree_bare_fat006: THREE.Mesh;
    tree_bare_fat007: THREE.Mesh;
  };
  materials: {
    grass: THREE.MeshStandardMaterial;
    river_material: THREE.MeshStandardMaterial;
    stream_material: THREE.MeshStandardMaterial;
    waterfall_material: THREE.MeshStandardMaterial;
    waterfall_edge_material: THREE.MeshStandardMaterial;
    wall: THREE.MeshStandardMaterial;
    backdrop: THREE.MeshStandardMaterial;
    rock: THREE.MeshStandardMaterial;
    forest_mat: THREE.MeshStandardMaterial;
  };
};

const Experience = () => {
  /**--------------
    Load island model
   -------------------*/
  const { nodes, materials } = useGLTF(
    '/models/island_latest.glb'
  ) as unknown as IslandType;
  //keyboard controls

  return (
    <>
      <StatsGl className='top-0 fixed left-0' showPanel={2} />
      {/* <OrbitControls makeDefault /> */}
      <IslandEnvironment />
      <Campfire scale={2} position={[5, 3.5, 0]} />

      <Suspense>
        <Leaves />
      </Suspense>

      <Waterfall
        river_geo={nodes.island_geo003_1.geometry}
        river_material={materials.river_material}
        stream_material_geo={nodes.island_geo003_2.geometry}
        stream_material={materials.stream_material}
        waterFall_geo={nodes.island_geo003_3.geometry}
        waterfall_material={materials.waterfall_material}
        waterfallEdge_geo={nodes.island_geo003_4.geometry}
        waterfall_edge_material={materials.waterfall_edge_material}
      />

      <StaticCollider>
        <PlatForm
          rocks_geo={nodes.island_geo003_7.geometry}
          platform_geo={nodes.island_geo003_5.geometry}
          falloff_geo={nodes.island_geo003_6.geometry}
        />
      </StaticCollider>

      <Brush nodes={nodes} forest_mat={materials.forest_mat} />

      <FlyingObjects />

      <Island
        islandMesh={nodes.island_geo003}
        islandmaterial={materials.grass}
      />

      <Controllers />

      {/* <Physics debug={true} timeStep={'vary'}>
      
        <KeyboardControls map={keyboardMap}>
          <Ecctrl
            disableFollowCam={false}
            // mode='FixedCamera'
            animated
            camInitDir={{ x: Math.PI / 8, y: 0 }}
            camInitDis={-20} // Initial camera distance
            camFollowMult={4}
            camUpLimit={1}
            maxVelLimit={2}
          >
            <Roy position={[0, -0.98, 0]} scale={2} />
          </Ecctrl>
        </KeyboardControls>
      </Physics> */}
    </>
  );
};
useGLTF.preload('/models/island-waterfall.glb');

export default Experience;
